export enum ErrorType {
  CACHE_NOT_FOUND = 'Cache not found',
}

export enum MembershipLevel {
  CLASSIC = 'CLASSIC',
  PLUS = 'PLUS',
  PREMIER = 'PREMIER',
}

export enum ClubCode {
  AL = '001',
  CA = '004',
  EC = '215',
  HI = '018',
  ACMO = '065',
  NM = '601',
  NNE = '036',
  TW = '258',
  TX = '252',
}

// enum for membership benefit levels
// notes: ranking is based on index from lowest level (classic) to highest level (premier-rv)

export enum MembershipBenefitLevels {
  Classic = 'classic',
  ClassicRv = 'classic-rv',
  Plus = 'plus',
  PlusRv = 'plus-rv',
  Premier = 'premier',
  PremierRv = 'premier-rv',
}

export enum RoleType {
  Primary = 'PR',
  AdultAssociate = 'AD',
  Dependent = 'DE',
  Associate = 'AS',
}

export enum MembershipTitles {
  CLASSIC = 'Classic',
  PLUS = 'Plus®',
  PREMIER = 'Premier®',
}
